module.exports = function (settingsService) {
    return {
        restrict: 'E',
        scope: {
            settingGroup: '@',
            settingName: '@'
        },
        link(scope) {
            settingsService.getSettingValue(scope.settingGroup, scope.settingName).then(function (value) {
                scope.settingValue = value;
            });
        },
        template: '{{settingValue}}'
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/settings/settings-directive.js
 **/